export default __webpack_public_path__ + "static/media/DAIF_Services_Screen2_in.d274f2ab.mp4";